"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VARIANTS = void 0;
var PrivaliaES_1 = __importDefault(require("./PrivaliaES"));
var PrivaliaIT_1 = __importDefault(require("./PrivaliaIT"));
var VeepeeDE_1 = __importDefault(require("./VeepeeDE"));
var VeepeeES_1 = __importDefault(require("./VeepeeES"));
var VeepeeFR_1 = __importDefault(require("./VeepeeFR"));
var VeepeeIT_1 = __importDefault(require("./VeepeeIT"));
var VeepeeNL_1 = __importDefault(require("./VeepeeNL"));
exports.VARIANTS = {
    privalia_es: PrivaliaES_1.default,
    privalia_it: PrivaliaIT_1.default,
    veepee_de: VeepeeDE_1.default,
    veepee_es: VeepeeES_1.default,
    veepee_fr: VeepeeFR_1.default,
    veepee_it: VeepeeIT_1.default,
    veepee_nl: VeepeeNL_1.default
};
